import { CognitoIdentityCredentials } from 'aws-sdk';
import * as AWS from '../constants/AWS';
import * as Auth from '../constants/Auth';
import { Dispatch } from 'redux';
import {
  CognitoUserSession
} from 'amazon-cognito-identity-js';

export const requestSignIn = (
  username: string, password: string,
  requestFunc: Function, fetchedFunc: Function) => {

  return (dispatch: Dispatch<any>) => {
    dispatch(requestFunc());
    let cognitoUser = AWS.cognitoUser(username);
    const authConfig = {
      onSuccess: () => {
        // FIXME: なぜかない
        // cognitoUser.cacheTokens();
        dispatch(fetchedFunc(Auth.SIGN_IN_STATUS_REDIRECTING));
        dispatch(fetchedFunc(Auth.SIGN_IN_STATUS_SUCCESS));
      },
      onFailure: (err: any) => {
        dispatch(fetchedFunc(false, err));
      },
      newPasswordRequired(userAttributes: any, requiredAttributes: any) {
        cognitoUser.completeNewPasswordChallenge(password, {}, authConfig);
        dispatch(fetchedFunc(Auth.SIGN_IN_STATUS_REDIRECTING));
        dispatch(fetchedFunc(Auth.SIGN_IN_STATUS_SUCCESS));
      }
    };
    cognitoUser.authenticateUser(
      AWS.authenticationDetail(username, password), authConfig);
  };
};

export const requestGetSession = (requestFunc: Function, fetchedFunc: Function) => {
  return (dispatch: Dispatch<any>) => {
    dispatch(requestFunc());

    const userPool = AWS.userPool();
    const cognitoUser = userPool.getCurrentUser();
    console.log(cognitoUser);

    if (cognitoUser != null) {
      cognitoUser.getSession(function(err: string, result: CognitoUserSession) {
        let loginObject = {};

        loginObject[AWS.cognitoIdpURL] = result.getIdToken().getJwtToken();
        AWS.config.region = process.env.REACT_APP_AWS_REGION;
        AWS.config.credentials = new CognitoIdentityCredentials({
          IdentityPoolId: String(process.env.REACT_APP_IDENTITY_POOL_ID),
          Logins: loginObject,
        });

        if (err) {
          dispatch(fetchedFunc(false, err));
        } else {
          dispatch(fetchedFunc(true));
        }
      });
    } else {
      dispatch(fetchedFunc(false, 'User is not signed-in'));
    }
  };
};

export const requestSignOut = (requestFunc: Function, fetchedFunc: Function) => {
  return (dispatch: Dispatch<any>) => {
    dispatch(requestFunc());
    let userPool = AWS.userPool();
    let cognitoUser = userPool.getCurrentUser();
    if (cognitoUser != null) {
      cognitoUser.signOut();
      dispatch(fetchedFunc(true));
    } else {
      dispatch(fetchedFunc(true));
    }
  };
};



// WEBPACK FOOTER //
// ./src/api/Auth.tsx